import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  NavbarMenu,
  NavbarMenuItem,
  useNavbarContext,
} from "@heroui/react";
import Cookies from 'js-cookie';

import LayoutType from 'src/shared/utils/layout_type';
import { useGetCurrentUserQuery, useLogoutMutation } from 'src/services/rtk_api/user/sessionApi';

const sections = [
  {
    header: 'ERP',
    items: [
      { label: 'Projects',   to: '/', layoutType: LayoutType.FRONT_SITE },
      { label: 'Inventory',  to: '/', layoutType: LayoutType.FRONT_SITE },
      { label: 'Purchase',   to: '/', layoutType: LayoutType.FRONT_SITE }, 
    ],
  },
  {
    header: 'BOM Tools',
    items: [
      { label: 'Find Part',   to: '/find-part', layoutType: LayoutType.FIND_PART },
      { label: 'BOM Quote',   to: '/bom-tool', layoutType: LayoutType.BOM_QUOTE },
      { label: 'BOM Check',   to: '/bom-check', layoutType: LayoutType.BOM_CHECK },
      { label: 'BOM Compare', to: '/bom_compare', layoutType: LayoutType.BOM_COMPARE }, 
    ],
  },
  {
    header: 'Contact',
    items: [
      { label: 'Contact Us',  to: '/contact-us', layoutType: LayoutType.FRONT_SITE },
    ],
  },
];

const MenuMobile = ({ layoutType }) => {
  const { setIsMenuOpen } = useNavbarContext();
  const reloadFrontLink = layoutType !== LayoutType.FRONT_SITE;
  const reloadAccountLink = layoutType !== LayoutType.ACCOUNT_SITE;
  
  const {data: currentUser, error, isLoading} = useGetCurrentUserQuery();
  const [logout, {isSuccess: logoutSuccess}] = useLogoutMutation();

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
  }

  useEffect(() => {
    if (logoutSuccess) {
      Cookies.remove('X-User-Token');
      window.location.href = '/'
    }
  }, [logoutSuccess]);

  const isUserLoggedIn = !isLoading && currentUser && !error;

  const getAccountSection = () => {
    if (isUserLoggedIn) {
      return {
        header: 'Account',
        items: [
          // { 
          //   label: `Signed in as ${currentUser.email}`, 
          //   to: null, 
          //   layoutType: null,
          //   isReadOnly: true 
          // },
          { 
            label: `${currentUser.credits || 0} Credits`, 
            to: null, 
            layoutType: null,
            isReadOnly: true 
          },
          { 
            label: 'Profile', 
            to: '/account', 
            layoutType: LayoutType.ACCOUNT_SITE 
          },
          ...(process.env.ALLOW_TEAMS === 'true'
          ? [
              { 
                label: 'Team', 
                to: '/account/teams', 
                layoutType: LayoutType.ACCOUNT_SITE 
              }
            ]
          : []),
          { 
            label: 'Projects', 
            to: '/account/my-boms', 
            layoutType: LayoutType.ACCOUNT_SITE 
          },
          ...(process.env.CHARGE_CREDITS_ON_QUOTE === 'true'
          ? [
              {
                label: 'Orders',
                to: '/account/orders',
                layoutType: LayoutType.ACCOUNT_SITE,
              },
              {

                label: 'Wallet Transactions',
                to: '/account/wallet',
                layoutType: LayoutType.ACCOUNT_SITE,
              }
            ]
          : []),
          { 
            label: 'My Addresses', 
            to: '/account/addresses', 
            layoutType: LayoutType.ACCOUNT_SITE 
          },
          { 
            label: 'Preferences', 
            to: '/account/preferences', 
            layoutType: LayoutType.ACCOUNT_SITE 
          },
          { 
            label: 'Log Out', 
            to: null, 
            layoutType: null,
            isLogout: true,
          },
        ],
      };
    } else {
      return {
        header: 'Account',
        items: [
          { label: 'Login', to: '/login', layoutType: LayoutType.FRONT_SITE },
        ],
      };
    }
  };


  const allSections = [...sections, getAccountSection()];

  return (
    <NavbarMenu>
      {allSections.map((sec, headIdx) => (
        <React.Fragment key={headIdx}>
          <NavbarMenuItem disabled>
            <span className="font-semibold">{sec.header}</span>
          </NavbarMenuItem>

          {sec.items.map((item, itemsIdx) => {
            // if (item.isReadOnly) {
            //   return (
            //     <NavbarMenuItem key={itemsIdx} className="pl-6 py-2 w-full">
            //       <div className="block w-full text-sm text-gray-600 cursor-default">
            //         <p className="font-semibold">Signed in as</p>
            //         <p className="font-semibold">{currentUser.email}</p>
            //       </div>
            //     </NavbarMenuItem>
            //   );
            // }
            if (item.isReadOnly) {
              return (
                <NavbarMenuItem key={itemsIdx} className="pl-6 py-2 w-full">
                  <div className="block w-full text-lm text-gray-600 cursor-default">
                    <p className="font-semibold">{item.label}</p>
                  </div>
                </NavbarMenuItem>
              );
            }


            if (item.isLogout) {
              return (
                <NavbarMenuItem key={itemsIdx} className="pl-6 py-2 w-full">
                  <button
                    onClick={handleLogout}
                    className={`block w-full text-left ${item.isDanger ? 'text-red-600' : ''}`}
                  >
                    {item.label}
                  </button>
                </NavbarMenuItem>
              );
            }

            return (
              <NavbarMenuItem key={itemsIdx} className="pl-6 py-2 w-full">
                <Link
                  to={item.to}
                  onClick={() => setIsMenuOpen(false)}
                  className="block w-full"
                  reloadDocument={layoutType !== item.layoutType}>
                  {item.label}
                </Link>
              </NavbarMenuItem>
            );
          })}
        </React.Fragment>
      ))}
    </NavbarMenu>
  );
}

export default MenuMobile;